<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      style="margin-top:1vh;"
      width="480px"
      :close-on-click-modal="false"
    >
      <div slot="title" class="title">说明</div>
      <div class="tip-container">
        <div class="tip-li" v-for="(item,index) in content" :key="index">
          <div class="li-title">{{ item.title }} <span class="li-other" v-if="item.other">({{item.other}})</span></div>
          <div class="li-content" v-for="(liItem,liIndex) in item.list" :key="liIndex">
            <div class="content-detail-li">
              <span class="detail-li-title">{{ liItem.title }}</span>{{liItem.detail}}
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: center; margin-top: 10px;" v-if="status == 1">上述支持查询最近一个月数据（企微官方限制）</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary"   @click="dialogVisible=false" >我知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'tipDialog',
  data() {
    return {
      dialogVisible: false,
      status: 1,
      content: [],
      content1: [
        {
          title: '一、创建群聊数',
          other: '',
          list: [
            {
              title: '',
              detail: '当前员工作为群主创建的群聊数，截止当前的总数，不受时间控件约束；'
            },
          ]
        },
        {
          title: '二、群聊人数',
          other: '',
          list: [
            {
              title: '',
              detail: '当前员工作为群主创建的群聊内人数，截止当前的总数，不受时间控件约束；'
            },

          ]
        },
        {
          title: '三、群聊消息数',
          other: '',
          list: [
            {
              title: '',
              detail: '当前员工创建的群内群聊消息总数，受时间控件约束；'
            }
          ]
        },
        {
          title: '四、活跃群成员数',
          other: '',
          list: [
            {
              title: '',
              detail: '当前员工创建的群聊中，在指定时间有发消息的成员数。'
            }
          ]
        },
        {
          title: '五、新增群聊数',
          other: '',
          list: [
            {
              title: '',
              detail: '指定统计时间内，员工新创建的群聊数。'
            }
          ]
        },
        {
          title: '六、新增群人数',
          other: '',
          list: [
            {
              title: '',
              detail: '指定统计时间内，员工新创建的群聊内人数总和。'
            }
          ]
        },
      ],
      content2: [
        {
          title: '一、近期波动',
          other:'',
          list: [
            {
              title: '',
              detail: '1、新增群聊数：统计时间内，全部员工新增的外部群聊数，去重；'
            },
            {
              title: '',
              detail: '2、活跃群成员数：统计时间内， 有发消息的成员数。'
            },
            {
              title: '',
              detail:`3、群聊消息数：统计时间内，所有外部群聊的消息总数。`

            },
            {
              title: '',
              detail: '4.群日均消息数：统计时间内，所有外部群聊的消息总数除以统计天数的平均值。'
            },
            {
              title: '',
              detail: '5.群聊总人数：统计时间内，所有外部群聊人数总和，不去重。'
            },
            {
              title: '',
              detail:`6、进/退群人数：统计时间内，所有外部群聊进/退群人数总和。`

            }
          ]
        },
        {
          title: '二、历史累计',
          other:'数据统计不随统计周期修改而变化',
          list: [
            {
              title: '',
              detail: '1、群聊总数：指截止今天的群聊总数，会变化，但不会随统计区间变化。'
            }
          ]
        },
      ]
    }
  },
  methods: {
    // val:1展示content1,2展示content2
    show(val) {
      this.content = val==1?this.content1:this.content2;
      this.status = val
      this.dialogVisible = true;
    },

  }
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
}
.tip-container {
  font-size: 14px;
  line-height: 22px;
  .tip-li {
    margin-bottom: 16px;
    .li-title {
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 12px;
      border-bottom: 1px solid #EEEFF3;
      color: rgba(0, 0, 0, 0.9);
      .li-other {
        color: rgba(0, 0, 0, 0.6);
      }
    }
    .li-content {
      font-size: 12px;
      font-weight: 400;
      .content-detail-li {
        white-space: pre-wrap;
        .detail-li-title {
          color: rgba(0, 0, 0, 0.9);
          font-weight: 500;
          margin-right: 8px;
        }
      }
    }
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  
}
.dialog-footer {
  /deep/.el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close {
    color: rgba(0, 0, 0, 0.6);
    background-color: #E6E6E6;
  }
  /deep/ .el-button {
    line-height: unset;
    padding: 5px 16px;
  }
}
/deep/ .el-dialog__header {
  padding: 28px 28px 10px 32px;
}
/deep/ .el-dialog__body {
  padding: 0 32px;
}
/deep/ .el-dialog__footer {
  padding: 24px 32px 32px;
}
</style>